lmApp
  .controller('ApplicationController', ['$scope', '$rootScope', '$routeParams', '$templateCache', 'AssetService', 'ShowcaseService', 'ToastService',
    function ($scope, $rootScope, $routeParams, $templateCache, AssetService, ShowcaseService, ToastService) {

      $scope.tab = 'settings';
      $scope.loading = false;
      $scope.currentApplication = null;
      $scope.currentPlatform = {};
      $scope.message = '';

      var _getApplication = function () {
        if ($routeParams.application) {

          $scope.loading = true;
          $rootScope.showLinearProgress('#appLoader');
          var service;

          switch ($routeParams.application) {
            case 'stockweb':
              service = _.find($rootScope._self.services, {name: 'app.stockweb'});
              break;

  /*          case 'stockios':
              service = _.find($rootScope._self.services, {name: 'app.stockios'});
              break;

            case 'stockand':
              service = _.find($rootScope._self.services, {name: 'app.stockand'});
              break;*/

            default:
              $scope.message = $templateCache.get('invalid/no-application.html');
              $scope.loading = false;
              $rootScope.hideLinearProgress('#appLoader');
              break;
          }
        }

        if (service) {
          $scope.currentService = service;
          AssetService.GetPlatforms(service.instance.platform.ext_id)
            .then(function (platformCollection) {
              if (platformCollection.length) {
                $scope.currentPlatform = platformCollection[0];
                if ($routeParams.application === 'stockweb') {
                  ShowcaseService.GetShowcases(platformCollection[0].id)
                    .then(function (showcaseCollection) {
                      $scope.currentApplication = _parseApplication(showcaseCollection);
                    })
                } else {
                  $scope.currentApplication = _parseApplication();
                }
              }

              $scope.loading = false;
              $rootScope.hideLinearProgress('#appLoader');
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason, 'silent');
              ToastService.Small({
                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                color: 'amber',
                icon: 'server-off',
                blocked: true
              }, 1000 * 3);
              $scope.loading = false;
              $rootScope.hideLinearProgress('#appLoader');
            });
        } else {
          $scope.loading = false;
          $rootScope.hideLinearProgress('#appLoader');
        }
      };

      var _parseApplication = function (collecion) {
        var application = {};

        switch ($scope.currentService.name) {
          case 'app.stockweb':

            application.aliases = $scope.currentService.instance.configuration.aliases;
            application.service_name = $scope.currentService.name;
            application.platform = $scope.currentService.instance.platform;
            application.platform.logo_url = $scope.currentService.instance.configuration.logo_url;
            application.platform.id = $scope.currentPlatform.id;
            application.platform.name = $scope.currentPlatform.name;

            var bg = _.find(collecion, {labels: ['promo.background.slider']});

            if (bg) ShowcaseService.GetTileByShowcaseId(bg.id)
              .then(function (collection) {
                if (!collection.length) return;

                application.background = {};
                application.background = ShowcaseService._ParseTile(collection[0]);
                application.background._PrivateData.showcase_id = bg.id;
              });

            var slider = _.find(collecion, {labels: ['promo.home.slider']});

            if (slider) ShowcaseService.GetTileByShowcaseId(slider.id)
              .then(function (collection) {
                if (!collection.length) return;

                application.banners = {};
                application.banners = ShowcaseService._ParseTile(collection[0]);
                application.banners._PrivateData.showcase_id = bg.id;
              });

            application.type = 'ott-web';
            break;
          case 'app.stockios':

            application.service_name = $scope.currentService.name;
            application.platform = $scope.currentService.instance.platform;
            application.platform.id = $scope.currentPlatform.id;
            application.platform.name = $scope.currentPlatform.name;

            application.type = 'ios';
            break;

          case 'app.stockand':

            application.service_name = $scope.currentService.name;
            application.platform = $scope.currentService.instance.platform;
            application.platform.id = $scope.currentPlatform.id;
            application.platform.name = $scope.currentPlatform.name;

            application.type = 'android';
            break;
        }

        $rootScope.currentPlatform = application.platform;

        return application;
      };

      if ($rootScope._self) {
        _getApplication();
      } else {
        var _onSelfUpdate = $scope.$on('self:update', function (event, data) {
          _getApplication();
        });
      }

      $scope.$on('$destroy', function () {
        if (_onSelfUpdate) _onSelfUpdate();
      });
    }
  ]);
